import React, { useEffect } from "react";
import Meta from "./../components/Meta";
import PageLoader from "./../components/PageLoader";
import { useRouter } from "./../util/router";

// Legacy /purchase/:plan route is retired. It now funnels into the unified
// /checkout flow so any remaining links (sign-in `next=`, expedited auth,
// bookmarks, marketing/email links) reach the working product checkout.
function PurchasePage(props) {
  const router = useRouter();

  useEffect(() => {
    const plan = router.query.plan;
    const coupon = router.query.coupon;
    const query =
      `/checkout?plan=${encodeURIComponent(plan)}` +
      (coupon ? `&coupon=${encodeURIComponent(coupon)}` : "");
    router.replace(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Meta title="Purchase" />
      <PageLoader />
    </>
  );
}

export default PurchasePage;
